export const loginDomainMappings = {
  'stunnr.co': 'login',
} as Record<string, string>
